export const tillagePracticeGraphTheme = {
    color: ['#C14022', '#ED8770', '#FFC3B5', '#FFB34E'],
};
